import React from 'react';
import jspdf from 'jspdf';
import { Provider } from 'react-redux';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import withStyles from '@material-ui/core/styles/withStyles';
import html2canvas from 'html2canvas';
import { Typography } from '@material-ui/core';
import { CompassIcon } from './Icons';
import LegendItem from '../../../panels/LegendItem';

import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { lightTheme, darkTheme } from '../../../../Config/theme';
import store from '../../../../redux/Store';
import PDFTemplate from './PDFTemplate';

class PDFTemplateProvider extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <ThemeProvider theme={lightTheme}>
                <Provider store={store}>
                    <PDFTemplate {...this.props} />
                </Provider>
            </ThemeProvider>
        );
    }
}

export default PDFTemplateProvider;